import { render, staticRenderFns } from "./ResumoCasamento.vue?vue&type=template&id=67e2ff3a&scoped=true&"
import script from "./ResumoCasamento.vue?vue&type=script&lang=js&"
export * from "./ResumoCasamento.vue?vue&type=script&lang=js&"
import style0 from "./ResumoCasamento.vue?vue&type=style&index=0&id=67e2ff3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2ff3a",
  null
  
)

export default component.exports